import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonConstant } from '@app/common/constant/common.constant';
import { SelectDropdownModel } from '@app/models/components/select-dropdown.model';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { ComponentsModule } from '../components.module';
import { Router } from '@angular/router';

@Component({
    selector: 'product-list',
    standalone: true,
    templateUrl: './product-list.component.html',
    styleUrls: ['./product-list.component.css'],
    imports: [
        CommonModule,
        NgxPaginationModule,
        ComponentsModule,
    ]
})
export class ProductListComponent implements OnInit {
    @Input()
	config: PaginationInstance = {
		id: 'products',
		currentPage: 0,
		itemsPerPage: 12,
		totalItems: 0,
	};

	@Input()
	products: OrdPdtModel[] = [];

	@Input()
	kind: string = '';

	@Input()
	cateCd: string = '';

	@Input()
	key: string = '';

	@Input()
	len: number = 0;

	@Input()
	total: number = 0;

	@Input()
	page: number = 0;

	@Input()
	pagination: boolean = true;

	@Input()
	lenOption: boolean = false;

	@Input()
	totalItem: boolean = false;

	@Input()
	displayType: string = 'LIST';

	@Input()
	displayFilter: boolean = true;

	@Input()
	isHideFilterBar: boolean = false;

	@Input()
	iconTotalReview: boolean = false;

	@Input()
	enableTotalReview: boolean = false;

	@Output()
	changeLen = new EventEmitter<SelectDropdownModel>();

	@Output()
	changePage = new EventEmitter<number>();

	urlHomePage = CommonConstant.SLASH;
	currentUrl: String = '';

	sortOptions: SelectDropdownModel[] = [
		{ label: '정렬 기준', value: '0' },
		{ label: '등록순', value: '1' },
		{ label: '낮은가격순', value: '2' },
		{ label: '높은가격순', value: '3' },
	];

	sortSelected: SelectDropdownModel = new SelectDropdownModel();

    constructor(private _router: Router) { }

    ngOnInit(): void {
        this.currentUrl = this._router.url;
    }

    onChangePage(page: number): void {
		this.changePage.emit(page);
	}

	onChangeLen(selected: SelectDropdownModel) {
		this.changeLen.emit(selected);
	}

	onChangeSortValue(selected: SelectDropdownModel): void {
		this.sortSelected = selected;
	}

}
